import request from 'assets/js/request.js';

// 登录
export function login(data) {
  return request({
    url: '/portfolio/gather/common/login',
    method: 'post',
    data: data
  });
}

// 发送验证码
export function sendCode(data) {
  return request({
    url: '/portfolio/gather/common/sendCode',
    method: 'post',
    data: data
  });
}

// 退出登录
export function logout(data) {
  return request({
    url: '/portfolio/gather/common/logout',
    method: 'post',
    data: data
  });
}